// The display face for the game HUD's big type (area names, the radio card).
// A condensed poster face reads at a glance over a moving scene the way the
// system UI font cannot. Loaded on first use, with system fallbacks so nothing
// waits on it.
export const HUD_FONT = "'Anton', 'Impact', 'Arial Narrow Bold', system-ui, sans-serif";

let loaded = false;
export function ensureHudFont() {
  if (loaded || typeof document === 'undefined') return;
  loaded = true;
  const l = document.createElement('link');
  l.rel = 'stylesheet';
  l.href = 'https://fonts.googleapis.com/css2?family=Anton&display=swap';
  document.head.appendChild(l);
}
